import React from 'react';
import { Loader } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
// import { useGetAccountInfo } from '../../../../../shared/hooks';
// import { useGetDkimList } from '../../hooks';
import { Center } from '../../../../../shared/styles';
import CopyInputBox from '../customdomainmapping/components/copyInputBox';
import { DKIMData, DKIMTable, DKIMTableContainer, Status } from './styles';

type RecordType = {
  type: string;
  host: string;
  value: string;
  verified: boolean;
};

const DkimRecordsView = ({ dkimData = {} }: any) => {
  const { t } = useTranslation();
  const dkimList = dkimData?.records
    ? [...(dkimData?.records?.dkim || []), dkimData?.records?.spfmx]
    : [];
  return (
    <DKIMData>
      <div className="dkim-header">
        <div>
          <div className="dkim-info">
            <div className="dkim-name">{t('settings.CNAME_DNS_record')}</div>
          </div>
          <div className="dkim-timestamp">
            <span className="value">
              {t('settings.CNAME_DNS_record_desc', {
                dkimdomainData: dkimData?.domain,
              })}
            </span>
          </div>
        </div>
      </div>
      {dkimList.length ? (
        <DKIMTableContainer>
          <DKIMTable>
            <thead>
              <tr>
                <th>{t('type')}</th>
                <th className="left">{t('host_value')}</th>
                <th className="left">{t('data')}</th>
                <th>
                  {t('contacts.import_contact.default_fields.contact.status')}
                </th>
              </tr>
            </thead>
            <tbody>
              {dkimList.map((record: RecordType, index: number) => (
                <tr key={index}>
                  <td className="dkim-table-data">{record.type}</td>
                  <td className="dkim-table-data">
                    <CopyInputBox
                      styles={{ width: '100%' }}
                      value={record.host}
                    />
                  </td>
                  <td className="dkim-table-data">
                    <CopyInputBox
                      styles={{ width: '100%' }}
                      value={record.value}
                    />
                  </td>
                  <td>
                    <Status
                      className={record.verified ? 'verified' : 'pending'}
                    >
                      {record.verified ? `${t('verified')}` : `${t('pending')}`}
                    </Status>
                  </td>
                </tr>
              ))}
            </tbody>
          </DKIMTable>
        </DKIMTableContainer>
      ) : (
        <Center minHeight="300px">
          <Loader />
        </Center>
      )}
    </DKIMData>
  );
};

export default DkimRecordsView;
